import { FunctionalComponent } from 'preact';
import { Nav } from '@accedo/spatial-nav';
import { stylesheet } from 'astroturf';

const styles = stylesheet`
  @import '##/styles/import.scss';

  .live-genre {
    display: flex;
    color: rgba(255, 255, 255, 1);
    border-radius: pxToVw(50);
    background: rgba(32, 32, 32, 1);
    margin-right: pxToVw(7);
    padding: pxToVh(12) pxToVw(37) pxToVh(14);
    font-family: barlow;
    font-style: normal;
    font-size: pxToVw(16);
    white-space: nowrap;

    &:global(.current-focus) {
      /* stylelint-disable-next-line declaration-no-important  */
      background-color: rgb(255 255 255) !important;
      color: rgba(0, 0, 0, 1);
    }

    &:global(.active) {
      background-color: rgb(123 123 123);
    }
  }

  .live-genre-focused {
    background: rgb(255 255 255);
    color: rgba(0, 0, 0, 1);
  }

  .live-genre-active {
    background: rgb(123 123 123);
  }
`;

type GenreItemProps = {
  title: string;
  id: string;
  onGenreFocus: (genreId: string, idx: number) => void;
  onGenreClick: (genreId: string, idx: number) => void;
  genreIndex: number;
};

export const LiveGenre: FunctionalComponent<GenreItemProps> = ({
  title,
  id,
  onGenreFocus,
  onGenreClick,
  genreIndex,
}) => (
  <Nav.Focusable
    id={id}
    onFocus={() => {
      onGenreFocus(title, genreIndex);
    }}
    onSelect={() => onGenreClick(title, genreIndex)}
  >
    <div className={styles.liveGenre}>{title}</div>
  </Nav.Focusable>
);
